import React, { useState } from 'react';
import styled from 'styled-components';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useParams } from 'react-router-dom';
import IP_URL from '../connect';
import PhoneInput from 'react-phone-input-2';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { selectUser } from '../../Redux/currentUserSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Main = styled.div`
  background-color: #f4f7fc;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  
`;

const Container = styled.div`
  padding: 20px;
  margin: 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s;
`;

const Section = styled.div`
  font-size: 1.3rem;
  margin-bottom: 25px;
  text-align: center;
  color: #007bff;
  font-weight: 600;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.2rem;
  position: relative;

  label {
    margin-bottom: 5px;
    font-weight: 500;
    color: #333;
  }

  input {
    padding: 6px;
    border-radius: 6px;
    height: 40px;
    border: 1px solid #ccc;
    font-size: 1rem;
    transition: border 0.2s ease;

    &:focus {
      border-color: #007bff;
      outline: none;
    }
  }

  svg {
    position: absolute;
    right: 15px;
    top: 45px;
    cursor: pointer;
    color: #666;
  }
`;

const ErrorMsg = styled.div`
  font-size: 0.9rem;
  margin-top: 5px;
  color: ${({ match }) => (match ? 'green' : 'red')};
  transition: color 0.2s ease;
`;

const Button = styled.button`
  width: 100%;
  padding: 1rem;
  background: ${({ disabled }) => (disabled ? '#a0c4ff' : '#007bff')};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-weight: 600;
  margin-top: 1rem;
  transition: all 0.3s;

  &:hover {
    background: ${({ disabled }) => (disabled ? '#a0c4ff' : '#0056b3')};
  }
`;

const AddUser = () => {
  const { meterId, userPhoneNumber, meterName } = useParams();
  const { token } = useSelector(selectUser);
  const [phone, setPhone] = useState('');
  const [userName, setUserName] = useState('');
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [loading, setLoading] = useState(false);

  const passwordsMatch = password1 && password2 && password1 === password2;
  const formValid = userName && phone && password1 && password2 && passwordsMatch;

  const AddUser = async () => {
    if (!formValid) {
      toast.error('Please fill all fields correctly.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${IP_URL}/user/assign-meter`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userName,
          phoneNumber: phone,
          password: password1,
          meterId
        })
      });

      const result = await response.json();
      if (result.success) {
        toast.success(result.message || 'User assigned successfully');
        setUserName('');
        setPhone('');
        setPassword1('');
        setPassword2('');
      } else {
        toast.error(result.message || 'Error assigning user');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to add/change user');
    } finally {
      setLoading(false);
    }
  };

  const formTitle =
    userPhoneNumber && userPhoneNumber !== 'null'
      ? `Change User ${userPhoneNumber} for Meter ${meterName} (ID: ${meterId})`
      : `Add User to Meter ${meterName} (ID: ${meterId})`;

  return (
    <Main>
      <Navbar />
      
      <Container>
        <Section>{formTitle}</Section>
        <InputContainer>
          <label>User Name:</label>
          <input
            type="text"
            placeholder="Enter User Name"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />
        </InputContainer>

        <InputContainer>
          <label>Phone Number:</label>
          <PhoneInput
            country="ke"
            value={phone}
            onChange={setPhone}
            inputStyle={{
              width: '100%',
              borderRadius: '6px',
              height: '45px',
              border: '1px solid #ccc'
            }}
            enableSearch
          />
        </InputContainer>

        <InputContainer>
          <label>Create Password:</label>
          <input
            type={showPassword1 ? 'text' : 'password'}
            placeholder="Enter password"
            value={password1}
            onChange={(e) => setPassword1(e.target.value)}
            required
          />
          {showPassword1 ? (
            <FaEyeSlash onClick={() => setShowPassword1(false)} />
          ) : (
            <FaEye onClick={() => setShowPassword1(true)} />
          )}
        </InputContainer>

        <InputContainer>
          <label>Confirm Password:</label>
          <input
            type={showPassword2 ? 'text' : 'password'}
            placeholder="Confirm password"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            required
          />
          {showPassword2 ? (
            <FaEyeSlash onClick={() => setShowPassword2(false)} />
          ) : (
            <FaEye onClick={() => setShowPassword2(true)} />
          )}
          {password2 && (
            <ErrorMsg match={passwordsMatch}>
              {passwordsMatch ? '✅ Passwords match' : '❌ Passwords do not match'}
            </ErrorMsg>
          )}
        </InputContainer>

        <Button
          type="button"
          onClick={AddUser}
          disabled={!formValid || loading}
        >
          {loading
            ? 'Processing...'
            : userPhoneNumber && userPhoneNumber !== 'null'
            ? 'Change User'
            : 'Add User'}
        </Button>
      </Container>
      <Footer />
    </Main>
  );
};

export default AddUser;
